import { getItem } from '../../helper/localstorage.helper';
import { get } from '../api.service';

export const resetPasswordForEmail = async (email: string) => {
    const language = getItem("i18nextLng");
    return await get(`/signup/forgot-password?email=${email}&language=${language}`);
};
